const LoadingAnimationP = () => {
  return (
    <div className="loading">
      <h2>Fetching podcasts</h2>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  )
}

export default LoadingAnimationP